import React from "react"
import Hidden from "@material-ui/core/Hidden"
// eslint-disable-next-line
import ScrollableAnchor from "react-scrollable-anchor"
// eslint-disable-next-line
import { configureAnchors } from 'react-scrollable-anchor'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
// core components
import GridContainer from "../../../components/Grid/GridContainer.jsx"
import GridItem from "../../../components/Grid/GridItem.jsx"

import productStyle from "../../../assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx"
import originMobileSrc from "../../../assets/img/test.png"

class FeaturesSection extends React.Component {
    render() {
        configureAnchors({offset: -60, scrollDuration: 300})

        const { classes } = this.props
        return (
            <div>
                <ScrollableAnchor id="features">
                    <div>
                        <div
                            className={classes.section}
                            style={{
                                padding: "30px 0px 80px 0",
                                backgroundColor: "rgb(247, 247, 247)",
                                borderBottom: "1px solid #ebebeb",
                            }}>
                            <GridContainer
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                <GridItem xs={12} sm={12} md={12}>
                                    <h2 className={classes.title}> Increase your bottom line </h2>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={10} style={{ display: "flex", justifyContent: "center" }}>
                                    <div className={classes.description}>
                                        Accelerate revenue growth by selling online through pick up, order ahead, and
                                        delivery orders. Do more business and watch your business grow! Improve order
                                        accuracy, increase ordering efficiency, and reduce manual order taking!
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </div>

                        <div className={classes.featuresSection}>
                            <GridContainer style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <GridItem xs={0} sm={0} md={0} lg={1} style={{ paddingLeft: 0, paddingRight: 0 }} />
                                <GridItem xs={12} sm={12} md={4} lg={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <GridContainer className={classes.featureBoxDescription} spacing={0}>
                                        <GridItem sm={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <i
                                                className="material-icons"
                                                style={{ color: "#FFC915", fontSize: "2.5rem" }}>
                                                brush
                                            </i>
                                        </GridItem>
                                        <GridItem sm={9} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>
                                            <div>
                                                {" "}
                                                <span className={classes.featureBoxTitle}>
                                                    {" "}
                                                    Fully customized for you{" "}
                                                </span>
                                            </div>
                                            <div>
                                                Branded to your business & engineered to give your business a
                                                competitive edge
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>

                                <GridItem xs={12} sm={12} md={4} lg={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <GridContainer className={classes.featureBoxDescription} spacing={0}>
                                        <GridItem sm={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <i
                                                className="material-icons"
                                                style={{ color: "#FFC915", fontSize: "2.5rem" }}>
                                                replay
                                            </i>
                                        </GridItem>
                                        <GridItem sm={9} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>
                                            <div>
                                                {" "}
                                                <span className={classes.featureBoxTitle}>
                                                    Optimized for repeat orders{" "}
                                                </span>
                                            </div>
                                            <div>
                                                Ordering has never been easier! Use loyalty program to encourage
                                                customers.
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>

                                <GridItem xs={12} sm={12} md={4} lg={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <GridContainer className={classes.featureBoxDescription} spacing={0}>
                                        <GridItem sm={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <i
                                                className="material-icons"
                                                style={{ color: "#FFC915", fontSize: "2.5rem" }}>
                                                folder_open
                                            </i>
                                        </GridItem>
                                        <GridItem sm={9} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>
                                            <div>
                                                {" "}
                                                <span className={classes.featureBoxTitle}> Own your customer data</span>
                                            </div>
                                            <div>
                                                Your customer data is yours to keep, market towards, and keep in touch
                                                with.
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem xs={0} sm={0} md={0} lg={1} style={{ paddingLeft: 0, paddingRight: 0 }} />
                            </GridContainer>

                            <GridContainer
                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                spacing={2}>
                                <GridItem xs={0} sm={0} md={0} lg={1} style={{ paddingLeft: 0, paddingRight: 0 }} />
                                <GridItem xs={12} sm={12} md={4} lg={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <GridContainer className={classes.featureBoxDescription}>
                                        <GridItem sm={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <i
                                                className="material-icons"
                                                style={{ color: "#FFC915", fontSize: "2.5rem" }}>
                                                share
                                            </i>
                                        </GridItem>
                                        <GridItem sm={9} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>

                                            <Hidden only={["xs", "sm", "md"]}>
                                                <div>
                                                    {" "}
                                                    <span className={classes.featureBoxTitle}> 100% Risk-free </span>
                                                </div>
                                                <div>We take 0% commission!</div>
                                                <div>No contract, cancellation or hidden fees!</div>
                                            </Hidden>

                                            <Hidden only={["lg", "xl"]}>
                                                <div>
                                                    {" "}
                                                    <span className={classes.featureBoxTitle}> 100% Risk-free </span>
                                                </div>
                                                <div>We take 0% commission! No contract, cancellation or hidden fees!</div>
                                            </Hidden>
                                                {/* Only Large */}
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>

                                <GridItem xs={12} sm={12} md={4} lg={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <GridContainer className={classes.featureBoxDescription}>
                                        <GridItem sm={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <i
                                                className="material-icons"
                                                style={{ color: "#FFC915", fontSize: "2.5rem" }}>
                                                computer
                                            </i>
                                        </GridItem>
                                        <GridItem sm={9} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>
                                            <div>
                                                {" "}
                                                <span className={classes.featureBoxTitle}>
                                                    User-friendly & responsive{" "}
                                                </span>
                                            </div>
                                            <div>
                                                Optimize the customer buying experience by utilizing modern UX practices
                                                and ease of use.
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>

                                <GridItem xs={12} sm={12} md={4} lg={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <GridContainer className={classes.featureBoxDescription}>
                                        <GridItem sm={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                            <i
                                                className="material-icons"
                                                style={{ color: "#FFC915", fontSize: "2.5rem" }}>
                                                work_outline
                                            </i>
                                        </GridItem>
                                        <GridItem sm={9} style={{ textAlign: "left", paddingLeft: 0, paddingRight: 0 }}>
                                            <div>
                                                {" "}
                                                <span className={classes.featureBoxTitle}>Flexible Parameters</span>
                                            </div>
                                            <div>
                                                Set hours of operations, delivery minimums, delivery fees & payment
                                                options!
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                                <GridItem xs={0} sm={0} md={0} lg={1} style={{ paddingLeft: 0, paddingRight: 0 }} />
                            </GridContainer>
                        </div>
                        <div
                            className={classes.section}
                            style={{
                                padding: "30px 1rem 0 1rem",
                                backgroundColor: "#fff",
                                borderBottom: "1px solid #ebebeb",
                            }}>
                            <GridContainer
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}>
                                <GridItem xs={0} sm={0} md={2} />
                                <GridItem xs={12} sm={12} md={5} style={{ textAlign: "left" }}>
                                    <h2 className={classes.optimizeBoxTitle}>
                                        {" "}
                                        Optimize your customers ordering experience{" "}
                                    </h2>
                                    <div className={classes.optimizeDescription}>
                                        Make It Butter applies state-of-the-art, best design practices. Expect a
                                        responsive, mobile-ready, and user-friendly experience without the hassle of
                                        downloading an app! Compatible on all platforms and devices!
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5} className={classes.mobilePictureWrapper}>
                                    <img
                                        src={originMobileSrc}
                                        alt="..."
                                        style={{ maxWidth: "16rem", maxHeight: "25rem" }}
                                    />
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </ScrollableAnchor>
            </div>
        )
    }
}

export default withStyles(productStyle)(FeaturesSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/FeaturesSection.jsx